import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import $ from "jquery";
import cogoToast from "cogo-toast";
import {GET_COLLECTION_AGGREGATE_DATA} from "../../api";
import {company, getPreSignedUrl, uploadPhoto} from "../../api/app";
const Buffer = require('buffer/').Buffer;

let searchableFields = [
    { field: 'name', isNumeric: false },
    { field: 'email', isNumeric: false }
]

const Company = () => {

    document.title = "Company";

    const token = localStorage.getItem('jwtToken');

    const [stateReady, setStateReady] = useState(false);
    const [editForm, setEditForm] = useState(false);
    const [editId, setEditId] = useState(0);
    const [cover_image, set_cover_image] = useState(null);

    useEffect(() => {
        let table = $('#td-company').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Company Report</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "company",
                        searchableFields,
                        pageSize: data.start,
                        format: 'json',
                        sort: { name: 1 },
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return data.name;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data?.slug || "Unavailable";
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return `<nav class="nav nav-icon-only"><a href=${data?.logo !== null ? data?.logo : "https://i.imgur.com/43l4qRv.jpg"} target="_blank" class="nav-link"><i class="fa fa-eye"></i> View Image</a></nav>`;
                    },
                    "targets": 2
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link edit_company"><i class="fa fa-pencil"></i> Edit</a> <a href="#" class="nav-link delete_company"><i class="fa fa-trash-alt"></i> Delete</a></nav>`
                    },
                    "targets": 3
                }
            ]
        });

        table.on('click', '.delete_company', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            $(".data-message").text(`Are you sure, you want to delete this company?`);
            $('#delete-data').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                company("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        reloadTable();
                        cogoToast.success("Company successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        table.on('click', '.edit_company', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            setEditForm(true);
            $('#name').prop("required", true);
            $('#description').prop("required", false);
            $('#image').prop("required", false);

            setEditId(extract_td.raw._id);
            $("#name").val(extract_td.raw.name);
            $("#description").val(extract_td.raw.bio);
            $("#link").val(extract_td.raw?.website)

            $('#company_form').parsley();

            $("#modalCompany").modal("show");

            return false;
        });

        return () => {
            table.destroy();
        }

    }, []);

    const reloadTable = () => {
        $('#td-company').DataTable().ajax.reload(null, false);
    };

    const clearForm = () => {
        $('#name').val(null);
        $('#description').val(null);
        $('#image').val(null);
        $('#link').val(null);
        set_cover_image(null);
        $('#company_form').parsley().destroy();
    }

    const handleShowModal = () => {
        setEditForm(false);
        $('#modalCompany').modal({backdrop: 'static', keyboard: false});
        $('#company_form').parsley();
        $("#modalCompany").modal("show");
    }

    const handleAddCompany = async(e) => {
        e.preventDefault();
        setStateReady(true);

        let name = $('#name').val();
        let bio = $('#description').val();
        let website = $('#link').val();
        let slug = $('#slug').val();

        let data = {
            name,
            bio,
            website,
            slug,
            logo: cover_image !== null ? await S3Upload() : null
        };

        if(editForm) {
            company("put", Object.assign(data, {id: editId})).then((result) => {
                setStateReady(false);

                if(!result.error) {
                    cogoToast.success("Data successfully updated.", {position: "top-right", hideAfter: 5});
                    resetForm("modalCompany", "company_form");
                    reloadTable();
                }
            });

            return false;
        }

        company("post", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Data successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalCompany", "company_form");
                reloadTable();
            }
        });
    }

    const handleFileUpload = (event) => {
        if(event.target.files[0] !== undefined && $('#image').parsley().isValid() !== false) {
            let reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = () => {
                set_cover_image(reader.result);
            };
            reader.onerror = () => {
                set_cover_image(null);
            };
        }
    }

    const S3Upload = () => {
        return getPreSignedUrl().then(async (response) => {
            if (response.error) {
                return false;
            }

            const config = {
                headers: {
                    'Content-Type': 'image/jpeg; charset=utf-8',
                    'x-amz-acl': 'public-read'
                }
            };

            const buffer = new Buffer.from(cover_image.replace(/^data:image\/\w+;base64,/, ""), 'base64')

            return uploadPhoto(response.payload.url, buffer, config).then((result) => {
                if (!result.error) {
                    return result.payload.url.replace(/\?.*$/g,"");
                }

                return null;
            });
        })
    };

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item active" aria-current="page">Company</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Company</h4>
                    </div>
                    <div className="d-none d-md-block">
                        <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5 outline-none" onClick={handleShowModal.bind()}><i className="wd-10 mg-r-5 fa fa-plus"></i> Add New</button>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Company List</h6>
                                <div className="d-flex tx-18">
                                    <a href="#" onClick={(e) => {e.preventDefault(); $('#td-company').DataTable().ajax.reload()}} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="td-company" className="table">
                                    <thead>
                                    <tr>
                                        <th className="wd-25p">Name</th>
                                        <th className="wd-25p">Slug</th>
                                        <th className="wd-25p">Logo</th>
                                        <th className="wd-25p">Action</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalCompany" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered wd-sm-650" role="document">
                        <div className="modal-content">
                            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                <div className="media align-items-center">
                                    <div className="media-body">
                                        <a href="" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close" onClick={clearForm.bind()}>
                                            <span aria-hidden="true">&times;</span>
                                        </a>
                                        <h4 className="tx-18 tx-sm-20 mg-b-2">Company</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                <form id="company_form" className="parsley-style-1" onSubmit={handleAddCompany.bind()}>
                                    <div id="nameWrapper" className="form-group parsley-input">
                                        <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Company Name<span className="tx-danger">*</span></label>
                                        <input id="name" type="text" className="form-control"
                                               placeholder="Enter compnany name"
                                               autoComplete="none"
                                               data-parsley-class-handler="#nameWrapper"
                                               required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Upload Logo</label>
                                        <input id="image" type="file" className="form-control"
                                               onChange={handleFileUpload.bind()}
                                               data-parsley-filemaxmegabytes="1"
                                               data-parsley-trigger="change"
                                               data-parsley-filemimetypes="image/jpeg, image/jpg, image/png"
                                               accept="image/jpeg, image/jpg, image/png"
                                        />
                                    </div>

                                    <div id="descriptionWrapper" className="form-group parsley-input">
                                        <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Description<span className="tx-danger">*</span></label>
                                        <textarea id="description" rows="5" className="form-control"
                                                  placeholder="Provide a description"
                                                  data-parsley-class-handler="#descriptionWrapper" required/>
                                    </div>

                                    <div id="linkWrapper" className="form-group parsley-input">
                                        <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Website Link</label>
                                        <input id="link" type="url" className="form-control"
                                               placeholder="Enter website link"
                                               autoComplete="none"
                                               data-parsley-class-handler="#linkWrapper"
                                        />
                                    </div>

                                    <div id="slugWrapper" className="form-group parsley-input">
                                        <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Slug</label>
                                        <input id="slug" type="text" className="form-control"
                                               placeholder="Enter slug name"
                                               autoComplete="none"
                                               data-parsley-class-handler="#slugWrapper"
                                        />
                                    </div>

                                    {stateReady ? <button disabled className="btn btn-success btn-block"><span
                                        className="spinner-border spinner-border-sm mg-r-10" role="status"
                                        aria-hidden="true"/><span id="status">Please Wait</span></button> : editForm ?
                                        <button className="btn btn-success btn-block">Update Company</button> :
                                        <button className="btn btn-success btn-block">Create Company</button>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation"
                     aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                        <div className="modal-content tx-14">
                            <div className="modal-header">
                                <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="mg-b-0 data-message">Empty</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                                <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Company;
